module.exports = __webpack_public_path__ + "img/team_kurt.45415ff5.jpg";